var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNewWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,8.576c.072-.064.137-.135.205-.2l6.1-6.141c.087-.087.178-.17.333-.318v2.82c0,.436.22.707.555.7s.552-.274.553-.71q0-1.745,0-3.49V0C7.082,0,5.47,0,3.856.005a.535.535,0,0,0-.391.166.542.542,0,0,0-.15.4.539.539,0,0,0,.559.546c.494.019.987.007,1.481.008H6.79c-.145.158-.217.246-.3.329Q5.011,2.945,3.528,4.434,1.866,6.106.21,7.778a.549.549,0,0,0-.061.806A.616.616,0,0,0,1,8.576Z",
    transform: "translate(5.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.984,8.831a.538.538,0,0,0-.652-.536.574.574,0,0,0-.442.643q.006,1.573,0,3.146c0,.6-.2.8-.786.8H1.888c-.578,0-.774-.2-.774-.771V1.9c0-.6.192-.786.8-.786H4.484c.489,0,.759-.207.753-.566C5.23.2,4.961,0,4.5,0H1.925A1.756,1.756,0,0,0,0,1.93V12.083A1.75,1.75,0,0,0,1.9,14H6.979c1.738,0,3.477.005,5.218,0a1.687,1.687,0,0,0,1.781-1.59C14.017,11.214,14,10.022,13.984,8.831Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewWindow);
export default __webpack_public_path__ + "static/media/icon_new_window.8412b5deaf74869fa20fb024567f6c7c.svg";
export { ForwardRef as ReactComponent };